import React, { useEffect } from 'react';
import { PresellPage } from './components/PresellPage';
import { initClickMagick } from './lib/clickMagick';
import { initMetaPixel } from './lib/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    initClickMagick();
  }, []);
  return <div className="min-h-screen w-full bg-white font-sans" data-id="element-0" data-mp="3fahwkp3t4p8y">
      <PresellPage data-id="element-1" data-mp="3fb9jlbjc9enm" />
    </div>;
}